import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { Button } from 'antd-mobile';
import '../../assets/css/sold-out.less';
import { GdImage } from '@gaodun.com/gui-pc';

const soldoutImg = require('../../assets/image/soldout.png');

type SoldOutProps = {
    text?: String;
    link?: String;
    title?: String;
    optionImg?: String;
} & Props;

class SoldOut extends React.Component<SoldOutProps & RouteComponentProps, State> {
    constructor(props) {
        super(props);
        this.state = {
            count: 3,
        };
        console.log(this.props);
    }
    componentDidMount() {
        this.pageInit();
    }
    timer = 0;
    linkToIndex = () => {
        const { link }: any = this.props;
        let url = link ? link : '/';
        this.timer && window.clearInterval(this.timer);
        this.props.history.replace(url);
    };
    pageInit() {
        this.timer = window.setInterval(() => {
            let { count } = this.state;
            if (count > 0) {
                this.setState({
                    count: count - 1,
                });
            } else {
                this.linkToIndex();
            }
        }, 1000);
    }
    render() {
        const { count } = this.state;
        const { text, title, optionImg } = this.props;
        return (
            <div className="sold-out">
                <GdImage className="sold-out-img" src={optionImg || soldoutImg} alt="" />
                <div className="sold-out-hd">{text || '已售罄'}</div>
                <div className="sold-out-text">
                    <span>{count}S</span>后自动跳转到{title || '首页'}
                </div>
                <Button inline size="small" type="primary" className="my-button" onClick={this.linkToIndex}>
                    立即跳转
                </Button>
            </div>
        );
    }
}
export default withRouter(SoldOut);
